import "./QuickTextTemplateTable.css";
import CustomTable from "components/common/table/CustomTable";
import { DEFAULT_PAGE_SIZE_OPTIONS } from "static/pagination";
import QuickTextTemplateTableToolbar from "./QuickTextTemplateTableToolbar";
import { useGetQuickTextTemplatesQuery } from "app/store/quickTextTemplates/api/quickTextTemplateApi";
import useQuickTextTemplateTable from "./useQuickTextTemplateTable";
import useQuickTextTemplateTableColumns from "./useQuickTextTemplateTableColumns";

const QuickTextTemplateTable = () => {
  const {
    handleRowClick,
    pagination,
    columnFilters,
    sorting,

    setPagination,
    setSorting,
    setColumnFilters,

    search,
    searchText,
    onSearchChange,
  } = useQuickTextTemplateTable();
  const columns = useQuickTextTemplateTableColumns();

  const { data, isLoading, isFetching } = useGetQuickTextTemplatesQuery(
    { query: { filters: columnFilters, pagination, search, sorting } },
    { refetchOnMountOrArgChange: true }
  );

  return (
    <div>
      <div className="trans-table__container trans-table__container--alternate">
        <CustomTable
          columns={columns}
          data={data || []}
          searchText={searchText}
          options={{
            enableTopToolbar: true,
            enableRowSelection: false,
            enableSorting: true,
            rowCount: data?.itemsCount || 0,
            defaultColumn: {
              size: 180,
            },
            muiSearchTextFieldProps: {
              placeholder: "Search",
              onPointerCancel: () => {
                onSearchChange("");
              },
            },
            state: {
              isLoading: isLoading || isFetching,
              showGlobalFilter: true,
              showColumnFilters: true,
              globalFilter: search,
              pagination,
              columnFilters,
              sorting,
            },
            manualPagination: true,
            manualFiltering: true,
            manualSorting: true,
            onPaginationChange: setPagination,
            onSortingChange: setSorting,
            onColumnFiltersChange: setColumnFilters,
            onGlobalFilterChange: onSearchChange,
            rowsPerPageOptions: DEFAULT_PAGE_SIZE_OPTIONS,
            muiTableBodyRowProps: ({ row }) => {
              const rowData = row?.original;

              return {
                onClick: () => {
                  handleRowClick(rowData);
                },
                sx: {
                  cursor: "pointer",
                },
              };
            },
            renderTopToolbar: ({ table }) => (
              <QuickTextTemplateTableToolbar table={table} />
            ),
          }}
        />
      </div>
    </div>
  );
};

export default QuickTextTemplateTable;
